export const checkIfApplePaySupported = () => {
  try {
    return !!ApplePaySession && ApplePaySession.canMakePayments();
  } catch {
    return false;
  }
};
